import * as types from '../constants/ActionTypes';
import { combineReducers } from 'redux';

const data = (state = false, action) => {
  switch (action.type) {
    case types.RESET_USER_DATA:
      return null;

    case types.RELOAD_USER_DATA:
      return action.payload;

    default:
      return state;
  }
}

const updateUserStatus = (state = false, action) => {
  switch (action.type) {
    case types.SET_UPDATE_USER_PENDING:
      return {
        ...state,
        isUpdateUserPending: action.isUpdateUserPending
      }

    case types.SET_UPDATE_USER_SUCCESS:
      return {
        ...state,
        isUpdateUserSuccess: action.isUpdateUserSuccess
      }

    case types.SET_UPDATE_USER_ERROR:
      return {
        ...state,
        updateUserError: action.updateUserError
      }

    default:
      return state;
  }
}

const user = combineReducers({
  data,
  updateUserStatus
});

export default user;





// WEBPACK FOOTER //
// ./src/store/reducers/user.js